import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { findInputError } from "../utils/findInputError";
import { isFormInvalid } from "../utils/isFormValid";
import InputError from "./InputError";

const RadioButtonField = ({
  label,
  name,
  options = [],
  validation,
  containerStyle,
  labelStyle,
  radioWrapperStyle,
  radioStyle,
  labelPlacement = "right",
  disabled,
  info,
  defaultValue,
  handleChange, // Prop to update parent state
}) => {
  const {
    control,
    formState: { errors },
    setValue, // Add setValue to manually update form state
  } = useFormContext();

  const inputError = findInputError(errors, name);
  const isInvalid = isFormInvalid(inputError);

  return (
    <div style={{ display: "flex", flexDirection: "column", rowGap: "5px", ...containerStyle }}>
      <div className="flex gap-2 items-center">
        <div style={{ fontSize: "13px", color: "#3B3B3B", ...labelStyle }}>{label}</div>
        {info && <span style={{ fontSize: "13px", color: "#3B3B3B" }}>{info}</span>}
      </div>

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || ""}
        rules={validation}
        render={({ field }) => (
          <div style={{ display: "flex", gap: "30px", flexWrap: "wrap", ...radioWrapperStyle }}>
            {options.map((option) => (
              <label
                key={option.value}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  cursor: "pointer",
                  opacity: disabled ? 0.6 : 1,
                }}
              >
                {labelPlacement === "left" && <span style={{ fontSize: "16px" }}>{option.label}</span>}
                <input
                  type="radio"
                  name={name}
                  value={option.value}
                  checked={field.value === option.value}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    setValue(name, selectedValue); // Update form state
                    if (handleChange) {
                      handleChange(selectedValue); // Update parent state
                    }
                  }}
                  disabled={disabled}
                  style={{...radioStyle, outline: "none"}}
                />
                {labelPlacement === "right" && <span style={{ fontSize: "16px" }}>{option.label}</span>}
              </label>
            ))}
          </div>
        )}
      />

      {isInvalid ? <InputError inputError={inputError} /> : <div style={{ height: "12px" }} />}
    </div>
  );
};

export default RadioButtonField;